/**
 * Return object containing internal parameters (calculated using IPC parameters) which are used to calculate SMD pad sizes and center to center distance
 * @module IPCSmdFootprintCalculator
 */
module.exports = {
	range: function(max, min) {
		return Math.abs(max - min);
	},

	sMax: function(LMax, TMin) {
		return LMax - 2 * TMin;
	},

	sMin: function(LMin, TMax) {
		return LMin - 2 * TMax;
	},

	//used for aluminum electrolytic component
	tTolAE: function(sTol, lTol) {
		return Math.sqrt(sTol * sTol + lTol * lTol) / 2;
	},

	//used for aluminum electrolytic component
	lTolAE: function(sTol, tTol) {
		return Math.sqrt(sTol * sTol + 2 * tTol * tTol) / 2;
	},

	sTolRMS: function(LRange, TRange) {
		return Math.sqrt(LRange * LRange + TRange * TRange + TRange * TRange);
	},

	sMaxActual: function(SMax, SDiff) {
		return SMax - SDiff / 2;
	},

	sMinActual: function(SMin, SDiff) {
		return SMin + SDiff / 2;
	},

	toeTolerance: function(LRange, FabTol, PlcTol) {
		return Math.sqrt(LRange * LRange + ((2 * FabTol) * (2 * FabTol)) + ((2 * PlcTol) * (2 * PlcTol)));
	},

	zMax: function(LMin, ToeGoal, ToeTolerance) {
		return LMin + 2 * ToeGoal + ToeTolerance;
	},

	heelTolerance: function(SMaxActual, SMinActual, FabTol, PlcTol) {
		var SDiffActual = SMaxActual - SMinActual;

		return Math.sqrt(SDiffActual * SDiffActual + ((2 * FabTol) * (2 * FabTol)) + ((2 * PlcTol) * (2 * PlcTol)));
	},

	gMin: function(SMaxActual, HeelGoal, HeelTol) {
		return SMaxActual - 2 * HeelGoal - HeelTol;
	},

	sideTol: function(WRange, FabTol, PlcTol) {
		return Math.sqrt(WRange * WRange + ((2 * FabTol) * (2 * FabTol)) + ((2 * PlcTol) * (2 * PlcTol)));
	},

	yRef: function(WMin, SideGoal, SideTol) {
		return WMin + 2 * SideGoal + SideTol;
	},

	C: function(ZMax, GMin) {
		return (ZMax + GMin) / 2;
	},

	X: function(ZMax, GMin) {
		return (ZMax - GMin) / 2;
	},

	toeMin: function(X, C, ToeTol, LMin) {
		return ((X + C) - (LMin + ToeTol)) / 2;
	},

	toeMax: function(ToeTol, ToeMin) {
		return (ToeMin + (ToeTol / 2));
	},

	heelMin: function(SMaxActual, HeelTol, GMin) {
		return ((SMaxActual - HeelTol) - GMin) / 2;
	},

	heelMax: function(HeelMin, HeelTol) {
		return (HeelMin + (HeelTol / 2));
	},

	sideMin: function(Y, WMin, SideTol) {
		return (Y - (WMin + SideTol)) / 2;
	},

	sideMax: function(SideMin, SideTol) {
		return (SideMin + (SideTol / 2));
	}
};
